<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgements</h1>
<p>I wish to express my thanks to:</p>
<ul>
<li><p>My long-standing friend Carol Boulton, proprietor of Russell Stables in West End, Southampton, and driving force behind the Epona Trust, for reading initial drafts and suggesting adjustments.</p></li>
<li><p>My oldest friend, Mike Roberts, for monitoring his recollections, six decades after the event, of our time living together in our student days, and the following year hitch-hiking the length of Norway with me but sadly without a camera. Half-a-century later with such apparatus to hand we crossed Siberia and Mongolia and a couple of years later ventured to the farthest-flung, windswept islands off the Atlantic coast of France.</p></li>
<li><p>Judith Blake for her customary patience in putting this book together while enduring repeated alterations and new text or illustrations turning up just when she thought a letter had been put to bed.</p></li>
<li><p>Lisa Rodrigues for editing the final draft and for her professional insights.</p></li>
<li><p>And Millie Townsend for her cartoons drawn to order to put a smile on readers’ faces.</p></li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?134310d8